import * as React from 'react'
// libs
import { useDispatch, useSelector } from 'react-redux'
// view components
import DashboardOption from './components'
// hooks
import { useShowModal } from 'hooks/useShowModal'
import { useCurrentUser } from 'hooks/useCurrentUser'
// views
import { ButtonContainer, Header, Wrapper } from './view'
// icons
import { CloseIcon } from 'components/UI/Icons'
// constants
import { Modals } from 'constants/modals'
// store
import { dashboardsSelector, setDashboardsData, currentDashboardSelector } from 'store/reducers/dashboards'

interface Props {
  closePopup: () => void
  onDashboardEditDone: (id: string) => void
}

export const DashboardsMenu: React.FC<Props> = ({ closePopup, onDashboardEditDone }) => {
  const dispatch = useDispatch()

  const {
    permissionsFromSecurityGroups: { manageDashboards }
  } = useCurrentUser()

  const { showModal } = useShowModal({ modalType: Modals.DASHBOARD_SETTINGS_MODAL })

  const dashboards = useSelector(dashboardsSelector)
  const currentDashboard = useSelector(currentDashboardSelector)

  const onAddClick = () => {
    closePopup()
    showModal({ shouldCreate: true })
  }

  const onDashboardClick = (dashboard: Record<string, any>) => () => {
    if (currentDashboard?.id !== dashboard.id) {
      dispatch(
        setDashboardsData({
          current: dashboard
        })
      )
    }
  }

  return (
    <Wrapper>
      <Header>
        <span>Select Dashboard</span>
        <CloseIcon right={0} onClick={closePopup} />
      </Header>

      {dashboards.map((dashboard) => (
        <DashboardOption
          key={dashboard.id}
          dashboard={dashboard}
          closePopup={closePopup}
          canManage={!!manageDashboards}
          onClick={onDashboardClick(dashboard)}
          onDashboardEditDone={onDashboardEditDone}
          isActive={currentDashboard?.id === dashboard.id}
        />
      ))}

      {manageDashboards && (
        <ButtonContainer onClick={onAddClick}>
          + add dashboard
        </ButtonContainer>
      )}
    </Wrapper>
  )
}

export default DashboardsMenu
